/**-------------------------------  Copyright ---------------------------------
This software has been developed by Orange Labs TGI/OLS/SOFT
Copyright (c) Orange Labs 2018

COPYRIGHT    : This file is the property of Orange Labs.
Copyright Orange Labs 2018, All Rights Reserved

This software is the confidential and proprietary information of Orange Labs.

You shall not disclose such Confidential Information and shall use it only
in accordance with the terms of the license agreement you entered into with
Orange Labs.

AUTHORS      : Orange Labs  TGI/OLS/SOFT
EMAIL        : soft.cybersec@orange.com
-----------------------------------------------------------------------------*/


import axios, { AxiosRequestConfig, AxiosResponse} from 'axios'
import {API_BASE_PATH, HTTP_LONG_TIMEOUT} from '@/utils/constants'

export class HTTPService {

    private static manageError(e: any) {
        let message: string
        let statusCode: string = ''
        let title: string = ''
        let detail: string = ''

        if (e.response) {
            statusCode = e.response.status
            message = statusCode.toString() + ' ' + e.response.statusText.toLowerCase()

            if (e.response.data && e.response.data.title) {
                title = e.response.data.title
            }

            if (e.response.data && e.response.data.detail) {
                detail = e.response.data.detail
            }

        } else if (e.request) {
            message = 'No response from server'

        } else {
            message = 'Internal error while preparing the request'
        }

        e.errorMessage = message
        e.errorStatusCode = statusCode
        e.errorTitle = title
        e.errorDetail = detail
        throw e
    }

    private serverConfig: AxiosRequestConfig = {
        baseURL: API_BASE_PATH + '/',
        timeout: 10000,
        headers: {'Content-Type': 'application/json'},
    }

    constructor(public setIsLoading: (isLoading: boolean) => void) {
    }

    public async get(url: string, config?: AxiosRequestConfig): Promise<AxiosResponse> {
        return this.launchRequest(() => axios.get(url, {...this.serverConfig, ...config}))
    }

    public async get_okta(url: string, config?: AxiosRequestConfig): Promise<AxiosResponse> {
        const uploadConfig: AxiosRequestConfig = {
            baseURL: this.serverConfig.baseURL,
            timeout: HTTP_LONG_TIMEOUT,
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json',
                'Sec-Fetch-Dest': 'document',
                'Sec-Fetch-Mode': 'navigate',
                'Sec-Fetch-Site': 'none',
                'Sec-Fetch-User': '?1',
              },
        }
        return this.launchRequest(() => axios.get(url, uploadConfig))
    }
    public async get_okta3(url:string){
        //console.log("get_okta3 01")
        window.location.href = url;
        //console.log("get_okta3 02")
        return this.get_okta2(url)

    }
    public async get_okta2(url:string){
        //console.log("get_okta2 01")
        const response = await fetch(url,{
            method: "GET",
            mode: 'no-cors',
            //redirect:'manual',
            referrer:'',
            headers:{
                'Content-Type': 'application/x-www-form-urlencoded',
                'Access-Control-Allow-Origin': '*',
                'Access-Control-Expose-Headers': 'Location',
              }
        });
        //console.log("get_okta2 02")
        //console.log(response)
        const body = await response.json();
        //console.log("get_okta2 03")
        //console.log(body)
        return body;
    }

    public async post(url: string, data: object): Promise<AxiosResponse> {
        return this.launchRequest(() => axios.post(url, data, this.serverConfig))
    }

    public async postMultipart(url: string, data: object): Promise<AxiosResponse> {
        const uploadConfig: AxiosRequestConfig = {
            baseURL: this.serverConfig.baseURL,
            timeout: HTTP_LONG_TIMEOUT,
            headers: {'Content-Type': 'multipart/form-data'},
        }
        return this.launchRequest(() => axios.post(url, data, uploadConfig))
    }

    public async patch(url: string, data: object): Promise<AxiosResponse> {
        return this.launchRequest(() => axios.patch(url, data, this.serverConfig))
    }

    public async put(url: string, data: object): Promise<AxiosResponse> {
        return this.launchRequest(() => axios.put(url, data, this.serverConfig))
    }

    public async delete(url: string): Promise<AxiosResponse> {
        return this.launchRequest(() => axios.delete(url, this.serverConfig))
    }

    private async launchRequest(request: () => Promise<AxiosResponse>) {
        let result: AxiosResponse

        this.setIsLoading(true)
        try {
            result = await request()
        } catch (e) {
            HTTPService.manageError(e)
        } finally {
            this.setIsLoading(false)
        }
        return result
    }
}
